import {getPrivateAxios} from '../../libs';

export const fetchGuideDocx = async (id: string) => {
  return getPrivateAxios()
    .get(`guides/${id}/docx`, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      },
    })
    .then((response) => {
      return response.data;
    });
};
